export default __webpack_public_path__ + "static/media/yuva.2d46e34c.png";